@for (option of options; track option) {
  <div
    class="accessible-skip-link"
    >
    @if (option.domElement) {
      <a
        role="link"
        class="goreact-btn primary-btn skip-link-btn"
        href="#{{option.id}}"
        (click)="handleSkipLinkClick($event, option)">{{option.linkText}}</a>
    }
  </div>
}
